import { VISIBLE } from 'src/constants/appConstants';
import { convertDataRpToRecord } from '../utils/dataModificaionUtil';

const replenishBtnClickHandlerUtil = ({
    isReportPaymentScreen,
    reportPaymentButtonVisibility,
    reviewBtnClickHandler,
    setErrForEmptyHrefIdField,
    patientIdMandatory,
    reportUsagePatientDetailsMandatory,
    patientDetails,
    t,
    setErrForEmptyPatientField,
    reportUsagePatientDetails,
    filteredProduct,
    getValidateItemsArr,
    myCaseRefId,
    usageDetails,
    dispatch,
    validateProductDetails,
    validateUnidPlanFeeItems,
}) => {
    if (isReportPaymentScreen && reportPaymentButtonVisibility === VISIBLE) {
        reviewBtnClickHandler();
    } else {
        setErrForEmptyHrefIdField(
            (patientIdMandatory ||
                reportUsagePatientDetailsMandatory?.includes('href')) &&
                patientDetails?.hrefId?.length < 1
                ? t('orders.reportsAndInvoice.viewReport.Referenceidrequired')
                : null
        );
        setErrForEmptyPatientField(
            (patientIdMandatory ||
                reportUsagePatientDetailsMandatory?.includes('name')) &&
                (patientDetails?.patientLastName?.length < 1 ||
                    patientDetails?.patientFirstName?.length < 1)
                ? t(
                      'reportUsage.procedure.unidSurgery.SurgeryOrReport.Patientrequired'
                  )
                : null
        );
        const validateItemsArr = getValidateItemsArr(convertDataRpToRecord(filteredProduct));
        validateItemsArr.map(
            (item) => item.accountOwned == undefined && delete item.accountOwned
        );
        const validateItemsObj = {
            myCaseRef: myCaseRefId,
            products: validateItemsArr,
        };
        if (
            (patientIdMandatory ||
            (reportUsagePatientDetails?.includes('href') &&
                reportUsagePatientDetailsMandatory?.includes('href'))
                ? patientDetails?.hrefId?.length > 0
                : true) &&
            (patientIdMandatory ||
            (reportUsagePatientDetails?.includes('name') &&
                reportUsagePatientDetailsMandatory?.includes('name'))
                ? patientDetails?.patientFirstName?.length > 0
                : true) &&
            (patientIdMandatory ||
            (reportUsagePatientDetails?.includes('name') &&
                reportUsagePatientDetailsMandatory?.includes('name'))
                ? patientDetails?.patientLastName?.length > 0
                : true) &&
            (reportUsagePatientDetails?.includes('sex') &&
            reportUsagePatientDetailsMandatory?.includes('sex')
                ? patientDetails?.patientSex.length > 0
                : true) &&
            (reportUsagePatientDetails?.includes('dob') &&
            reportUsagePatientDetailsMandatory?.includes('dob')
                ? patientDetails?.patientDOB
                : true) &&
            filteredProduct.length > 0 &&
            myCaseRefId
        ) {
            const validateItemsArr = getValidateItemsArr(convertDataRpToRecord(filteredProduct));
            validateItemsArr.map(
                (item) =>
                    item.accountOwned == undefined && delete item.accountOwned
            );
            const validateItemsObj = {
                myCaseRef: myCaseRefId,
                products: validateItemsArr,
            };
            if (usageDetails.unidId) {
                dispatch(validateUnidPlanFeeItems(validateItemsObj, true));
            } else {
                dispatch(validateProductDetails(validateItemsObj, true));
            }
            dispatch({
                type: 'SET_ITEMS_PRICING_DONE_FLAG',
                payload: false,
            });
        }
    }
};

export default replenishBtnClickHandlerUtil;
